import { AxiosResponse } from "axios";
import { ApiViaCep } from "../../Apis/ViaCepApi";
import { IViaCep } from "../../types/viaCep";

export class ViaCep {
  static async get(cep: string): Promise<AxiosResponse<IViaCep>> {
    return ApiViaCep.get(`${cep}/json`);
  }
}
